import { render } from "./MenuDetailMain.vue?vue&type=template&id=019ff9ad&scoped=true"
import script from "./MenuDetailMain.vue?vue&type=script&lang=js"
export * from "./MenuDetailMain.vue?vue&type=script&lang=js"

import "./MenuDetailMain.vue?vue&type=style&index=0&id=019ff9ad&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019ff9ad"]])

export default __exports__